import React, { type ReactNode } from 'react';

import { Interior, ScrollContainer, Sidebar } from './FiltersSidebar.style';

export interface FiltersSidebarProps {
    scrollable?: boolean;
    sticky?: boolean;
    children: ReactNode;
}

export function FiltersSidebar({ scrollable = false, sticky = false, children }: FiltersSidebarProps) {
    return (
        <Sidebar $sticky={sticky}>
            <Interior>
                <ScrollContainer $scrollable={scrollable}>{children}</ScrollContainer>
            </Interior>
        </Sidebar>
    );
}
